export default {
  wallet: {
    tooltips: {
      cardInfo:
        'Feel free to add your card details; hubmee securely protects any of your confidential information. You can constantly update or change the data if necessary.',
      billingHistory:
        'This is your handy payment history where you can find the details of each of them. You will also see a notice about an upcoming payment. So enjoy hubmee with complete confidence in the safety of your data!',
    },
    cardInfo: {
      cardInfoDescription:
        'Be sure that all your data is securely protected. We care about the privacy and security of hubmee users and always pay special attention to this.',
    },
    billingHistoryInfo: {
      billingHistoryInfoTitle: {
        includes: 'Includes',
        unitPrice: 'Unit price',
      },
      billingHistoryInfoIncludes: {
        personalHub: 'Personal Hub',
        garage: 'Garage',
        roadmap: 'Roadmap',
        events: 'Events',
        backlog: 'Backlog',
      },
      billingHistoryInfoStatus: {
        paid: 'Paid',
        upcoming: 'Upcoming',
        declined: 'Declined',
      },
    },
    payment: {
      faq: {
        header: 'FAQ',
        title: {
          firstPaymentDue: 'When is my first payment due?',
          policy: 'What’s hubmee’s refund policy?',
          switchPlans: 'Can I switch plans at any time?',
        },
        text: {
          firstPaymentDue: 'One month after you paid for the plan.',
          policy:
            'You get a 14 day money back guarantee only on annual plans. If you’re interested in learning more go to Terms of use. Got more questions - you can always ask hubmee support.',
          switchPlans: 'Yes, you can. The upgrade will occur as soon as soon as you change it.',
        },
      },
      billingIssue: {
        recommend: {
          firstPart: 'There is a billing error and your payment for',
          secondPart:
            'has expired. It can occur due to insufficient funds or an expired card. We recommend that you pay again with your current card or edit your card info. This will allow you to use hubmee services without any interruptions',
        },
        inform:
          'We would like to inform you that if you don’t update your card information, you will lose access to any paid services you’re currently using and will automatically switch to the Starter package. Please note that you can regain access to the previously lost features anytime, by activating them.',
      },
      itemContent: {
        title: {
          paymentId: 'Payment Id',
          dueDate: 'Due-date',
          amount: 'Amount',
          status: 'Status',
          documents: 'Documents',
        },
      },
    },
  },
};
